<icc-dimensions-legend [shape]="shape?.shape" [variant]="shape?.type" highlight="all"></icc-dimensions-legend>

<form [formGroup]="dimensionsForm">
  @for (field of fields; track field) {
    @if (field.field) {
      <mat-form-field >
        @if (field.name == 'width') {
          <mat-label translate>PLEATED_BLIND|Szerokość (S)</mat-label>
        }
        @if (field.name == 'height') {
          <mat-label translate>PLEATED_BLIND|Wysokość (H)</mat-label>
        }
        @if (field.name == 'h1') {
          <mat-label >H1</mat-label>
        }
        @if (field.name == 'h2') {
          <mat-label >H2</mat-label>
        }
        @if (field.name == 'h3') {
          <mat-label >H3</mat-label>
        }
        @if (field.name == 's1') {
          <mat-label >S1</mat-label>
        }
        @if (field.name == 's2') {
          <mat-label >S2</mat-label>
        }
        @if (field.name == 's3') {
          <mat-label >S3</mat-label>
        }
        @if (field.name == 'diameter') {
          <mat-label>{{ 'PLEATED_BLIND|Średnica (S):' }}</mat-label>
        }
        @if (field.name == 'perimeter') {
          <mat-label>{{ 'PLEATED_BLIND|Obwód:' }}</mat-label>
        }
        <input matInput iccDimensionInput type="number" [formControlName]="field.field" inputmode="decimal">
        <span matPrefix>
          <icc-dimensions-legend [shape]="shape?.shape" [variant]="shape?.type" [highlight]="field.highlight || field.field" [fieldPrefix]="true"></icc-dimensions-legend>
        </span>
        <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
      </mat-form-field>
    }
    @if (field.value) {
      <span>
        <p>{{field.value}}</p>
        <span>{{dimensionUnit.unitSymbol}}</span>
      </span>
    }
  }
</form>
